import React, { Component } from 'react'
import { InputNumber, Button, Select, Icon, Skeleton, Tooltip } from 'antd'
import Col from 'react-bootstrap/Col'
import '../../wallet.css'
import './transferir.css'
import { Row } from 'react-bootstrap'
import NovoFavorecido from './novoFavorecido'
import ListaFavoritos from './listaFavoritos'
import { loadFees } from '../../../../redux-flow/actions/wallet_btc'
import { connect } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'

const Option = Select.Option

const LoadingComponent = () => (
    <div style={{ textAlign: 'center' }}>
        <Icon type="loading" />
    </div>
)

class Transferir extends Component {
    constructor(props) {
    super(props)
    this.state = {
        tabAtiva: 'novo',    
        fee: 0,
        value: 0,
        priority: 'standard',
        size: 1200
    }}

    componentDidMount() {
        const { onLoad, isLoading } = this.props
        if (onLoad) {
            onLoad()
        }
        if(!isLoading) {
            this.setState({
                fee: this.props.fees.standard
            })
        }

    }

    onClickTab = (id) => {
        if(this.state.tabAtiva != id){
            this.setState({tabAtiva:id})
        }
    }

    onChangeFee = (e, all) => {
        let size = 0
        if(all.props.name === 'standard') {
            size = 2400
        } else if(all.props.name === 'fast') {
            size = 4800
        } else {
            size = 1200
        }
        this.setState({
            fee: e,
            priority: all.props.name,
            size
        })
    }

    getValue = (e) => {
        this.setState({
            value: e.target.value
        })
    }

        render() {
            const { isLoading, success, fees, cashSuccess, message } = this.props
            console.log(fees)
            return (
    
                <>              
                            <Row className='p-0b btcTransferir'>
                                <Col md={12} className="mb-3">
                                    <label className="tx-grey">Para enviar BTC, insira o endereço público da carteira de destino.<br />Certifique-se que este endereço pertença a uma carteira na rede Bitcoin.</label>
                                </Col>
                                <Col md={6}>
                                    <Row>
                                        <Col md={12}>
                                            {!cashSuccess && message != null &&
                                                <div class="alert alert-danger fade show" style={{width: 'max-content'}} role="alert">
                                                    <p className="mb-0">{message}</p>
                                                </div>
                                            }
                                            <label className='titulosTransferirBtc mb-2 p-0'>Informe o valor</label> 
                                        
                                            <div className='divInputValorBtc'>
                                                <label className='moedaBtc'>BTC</label>
                                                
                                                <InputNumber
                                                    onKeyUp={(e) => this.getValue(e)}
                                                    className="inputValor"
                                                    // formatter={value => this.currencyFormatter(value)}
                                                    max={100000000}
                                                    // parser={value => String(value).replace(/\D/g, '')}
                                                    style={{ width: '100%' }}
                                                />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                                <label className='titulosTransferirBtc mt-3 mb-2 p-0'>Escolha a prioridade</label> <br />
                                                {isLoading ? <Skeleton active title={{width: 350}} paragraph={false} /> : success ?
                                                <Select onChange={(e, all) => this.onChangeFee(e, all)} className="inputTransferir" defaultValue={fees.standard}>
                                                    <Option name="standard" value={fees.standard}>Normal</Option>
                                                    <Option name="fast" value={fees.fast}>Alta</Option>
                                                    <Option name="slow" value={fees.slow}>Baixa</Option>
                                                </Select> : 'Houve um erro ao carregar as taxas. Por favor, tente novamente.' }
                                        </Col>
                                    </Row>
                                    
                                </Col>

                                <Col md={1}></Col>

                                <Col md={5}>
                                    <div>
                                        <label className='titulosTransferirBtc mb-2 p-0'>Cálculo da transação<Tooltip title="Este valor é a taxa aproximada e pode sofrer alterações após a confirmação da transação. O valor excedente será estornado em seu saldo." className="ml-2"><FontAwesomeIcon icon={faInfoCircle} /></Tooltip></label> 
                                    </div>
                                    <div>
                                        <label className='textoTaxaBtc mb-2 p-0'>Taxa aproximada: { isLoading ? 0 : (this.state.fee || fees.standard)} BTC</label> 
                                    </div>
                                    <div>
                                        <label className='titulosTransferirBtc mb-2 p-0'>Total da transação</label> 
                                    </div>
                                    <div>
                                        <label className='moedaTransTotalBtc mr-2'>BTC</label>
                                        <label className='valorTransTotalBtc mb-2 p-0'>{this.state.value != 0 ? (parseFloat(this.state.value) + (parseFloat(this.state.fee || fees.standard))).toFixed(8) : 0}</label> 
                                    </div>
                                </Col>

                            </Row>
                            <Row className="btcTransferir">
                                <Col md={12}>
                                    <hr className="linhaHorizontal" />
                                </Col>
                                <Col md={12}>
                                    <label className='titulosTransferirBtc mt-3 mb-2'>Favorecido</label> 
                                </Col>

                                {/* <Col md={6}>
                                    <div className='divTipoFavorecidoBtc mt-1'>
                                        <Col md={3} className='p-0 mr-1'>
                                            <div id='novo' className={`tabFavBtc ${this.state.tabAtiva == 'novo' ? 'tabFavBtcActive' : ''}`} onClick={() => this.onClickTab('novo')}>
                                               <label className='nomeTabTransfBtc'>Novo</label>
                                            </div> 
                                        </Col>

                                        <Col md={3} className='p-0 ml-1'>
                                            <div id='favoritos' className={`tabFavBtc ${this.state.tabAtiva == 'favoritos' ? 'tabFavBtcActive' : ''}`} onClick={() => this.onClickTab('favoritos')}>
                                                <label className='nomeTabTransfBtc'>Favoritos</label>
                                            </div> 
                                        </Col>                                  
                                    </div>
                                </Col> */}

                                <Col md={12} className='mt-4'>
                                    {this.state.tabAtiva == 'novo' ?                                             
                                            <NovoFavorecido size={this.state.size} fee={this.state.fee || fees.standard} value={this.state.value} priority={this.state.priority} /> : <ListaFavoritos isLoading={this.props.isLoading} favorites={this.props.favorites} />}
                                </Col>

                            </Row>                            
                </>
            )
        }
    }

const mapStateToProps = state => ({
    fees: state.wallet_btc.fees,
    isLoading: state.wallet_btc.isLoadingFees,
    success: state.wallet_btc.success,
    cashSuccess: state.wallet_btc.cashSuccess,
    message: state.wallet_btc.cashMessage
})
    
const mapDispatchToProps = dispatch => ({
    onLoad: () => {
        dispatch(loadFees())
    }
})
    
export default connect(mapStateToProps, mapDispatchToProps)(Transferir)